import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  currentTheme = signal<string>('theme-dashly');

  setTheme(theme = ''): void {
    const body = document.body;

    body.classList.remove('theme-dashly');
    if (theme) {
      body.classList.add(theme);
    }
    this.currentTheme.set(theme);
  }
}
